var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0504 18.7377C21.0504 24.2603 16.6039 28.7374 11.1188 28.7374C5.63363 28.7374 1.1875 24.2616 1.1875 18.7377C1.1875 13.2137 5.63396 8.73828 11.1188 8.73828C16.6036 8.73828 21.0504 13.2151 21.0504 18.7377Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.947 18.7362C31.947 23.935 29.7237 28.1491 26.9813 28.1491C24.239 28.1491 22.0156 23.9337 22.0156 18.7362C22.0156 13.5387 24.239 9.32324 26.9813 9.32324C29.7237 9.32324 31.947 13.5387 31.947 18.7362Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3993 18.7363C36.3993 23.3943 35.6172 27.17 34.6528 27.17C33.6883 27.17 32.9063 23.3929 32.9063 18.7363C32.9063 14.0798 33.6883 10.3027 34.6531 10.3027C35.6179 10.3027 36.3993 14.0788 36.3993 18.7363Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.7bd723fd8925c016f8a76c3fea95597a.svg";
export { ForwardRef as ReactComponent };